import React from 'react';
import { CTAButton } from './CTAButton';
export function CommonMistakes() {
  return <section className="py-12 md:py-20 relative" data-id="element-48">
      <div className="container mx-auto px-4" data-id="element-49">
        <div className="max-w-4xl mx-auto" data-id="element-50">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-center mb-4 md:mb-6 text-white" data-id="element-51">
            El problema siempre fue el mismo.
          </h2>

          <p className="text-sm md:text-lg text-zinc-400 text-center mb-8 md:mb-12 max-w-2xl mx-auto" data-id="element-52">
            El asado en Argentina no se enseña. Se hereda. Si te tocó un viejo,
            un tío o un abuelo que te lo transmitió paso a paso: tuviste suerte.
            Si no te tocó: quedaste librado a YouTube donde los cortes no son
            los mismos, a los grupos de WhatsApp donde todos opinan distinto, a
            los videos de afuera donde el vacío no existe y el chimichurri lo
            hacen con cosas que acá no se consiguen.
          </p>

          <p className="text-base md:text-xl text-zinc-300 text-center mb-6 md:mb-8 font-semibold" data-id="element-53">
            Y el resultado es siempre el mismo. Improvisás. A veces sale. A
            veces no. Y nunca sabés exactamente por qué.
          </p>

          <h3 className="text-xl md:text-3xl font-serif font-bold text-center mb-6 text-amber-400" data-id="element-54">
            ¿Te suena alguna de estas?
          </h3>

          <div className="space-y-4 mb-12" data-id="element-55">
            {['Pusiste el vacío dos horas y salió seco igual.', 'La entraña quedó dura y no entendés qué hiciste mal.', 'El costillar tardó tres horas más y los pibes ya habían comido el pan.', 'Le preguntaste al carnicero qué llevar y te dio el más caro sin explicarte nada.', 'Buscaste en Google y encontraste cinco respuestas distintas para la misma pregunta.', 'Te da fiaca hacerte cargo del asado porque no querés quedar como un boludo frente a todos.'].map((text, i) => <div key={i} className="flex items-start p-3 rounded-lg hover:bg-zinc-900/50 transition-colors" data-id="element-56">
                <span className="text-red-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-57">
                  ✕
                </span>
                <p className="text-zinc-300 text-sm md:text-base" data-id="element-58">{text}</p>
              </div>)}
          </div>

          <div className="text-center bg-zinc-950 border border-amber-900/30 p-6 md:p-8 rounded-2xl" data-id="element-59">
            <p className="text-base md:text-xl text-zinc-300 mb-2" data-id="element-60">
              Si dijiste que sí a aunque sea una:
            </p>
            <p className="text-xl md:text-3xl font-bold text-amber-500 mb-6" data-id="element-61">
              Este sistema es para vos.
            </p>
            <CTAButton text="🔥 QUIERO DOMINAR EL ASADO →" data-id="element-62" />
          </div>
        </div>
      </div>
    </section>;
}